import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useCallback } from "react";
import RouteIcon from "@mui/icons-material/Route";
import CancelIcon from "@mui/icons-material/Cancel";
import TimelineIcon from "@mui/icons-material/Timeline";
import MapRunningClub from "../../../../components/Map/MapRunniClub";

const ModalViewRunningClub = ({ open, setOpen, selectedRunningClub }) => {
  const handleClose = useCallback(() => setOpen(false), [setOpen]);

  return (
    <Dialog open={open}>
      <DialogContent
        sx={{
          padding: 5,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 3,
        }}
      >
        <DialogTitle>
          <Typography sx={{ textAlign: "center", fontSize: 24 }}>
            {selectedRunningClub?.nameRunningClub ?? "Club de entrenamiento."}
          </Typography>
        </DialogTitle>
        <Box
          sx={{
            backgroundColor: "rgba(128, 128, 128, 0.55)",
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 2,
            paddingBottom: 2,
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <RouteIcon className="text-primary " />
                <Typography>Nivel</Typography>
              </Box>
              <Typography className="text-primary ">
                {selectedRunningClub?.level ?? 0}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <TimelineIcon className="text-primary " />
                <Typography>Tipo de entrenamientos.</Typography>
              </Box>
              <Typography className="text-primary ">
                {selectedRunningClub?.typeTraining ?? ""}
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography>Horarios de entrenamiento.</Typography>
            <Box>
              {selectedRunningClub?.trainingDays &&
                selectedRunningClub?.trainingDays.map((day, index) => (
                  <Typography key={index} className="text-primary">
                    {day?.day ?? "Día"}:
                    {day?.times &&
                      day.times.map((time, index) => {
                        return ` ${time} hrs ${index === selectedRunningClub?.trainingDays.length - 1 ? "." : ","}`;
                      })}
                  </Typography>
                ))}
            </Box>
          </Box>
        </Box>
        <Box sx={{ width: 450, height: 350 }}>
          <MapRunningClub runningClub={selectedRunningClub} setOpen={setOpen} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="outlined"
            sx={{ borderColor: "white", color: "white" }}
            onClick={handleClose}
            startIcon={<CancelIcon />}
          >
            Cerrar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ModalViewRunningClub;
